import {
  Get_Languages,
  Get_Lead_Origin_Sub_Types,
  Get_Lead_Sources,
  Get_Preferred_Contact,
  Get_Statuses,
} from "@/modules/crm/leads/graphql-queries/general-queries";
import { Get_Tag_Colors, Get_Tags } from "../leads/graphql-queries/leadTag";
import {
  Get_Template_Categories,
  Get_Workflows_Options,
} from "../automation/graphql-queries";
import {
  Get_Call_Purpose,
  Get_Call_Results,
  Get_Task_Priorities,
  Get_Task_Statuses,
  Get_Task_Types,
} from "../leads/graphql-queries/task-settings";
import { Get_Report_Categories_only } from "../analytics/graphql-queries";

/** @name: @dropdownOptionsQueries
 *  @params: params which required by gql queries
 *  @description: define queries to fetch data
 */
const dropdownOptionsQueries = (params, isCRM = true) => {
  const { companyId, searchText } = params;
  if (!isCRM) return [];
  const queries = [
    {
      query: Get_Statuses,
      key: "leadStatuses",
    },
    {
      query: Get_Lead_Sources,
      key: "leadSources",
      params: { order: { sortOrder: "ASC" } },
    },
    // {
    //   query: Get_Languages,
    //   key: "languages",
    //   params: {
    //     searchText,
    //   },
    // },
    {
      query: Get_Preferred_Contact,
      key: "preferredContact",
      bypassPublicPageCheck: true,
    },
    {
      query: Get_Tags,
      key: "tags",
      subKey: "items",
    },
    {
      query: Get_Tag_Colors,
      key: "tagColors",
      subKey: "items",
    },
    {
      query: Get_Template_Categories,
      key: "wfTemplateCategories",
      subKey: "items",
    },
    {
      query: Get_Workflows_Options,
      key: "workFlows",
      subKey: "items",
      params: {
        order: { id: "DESC" },
        where: {
          workflowRunStatus: {
            eq: 2,
          },
        },
        skip: 0,
        take: 100,
      },
    },
    {
      query: Get_Report_Categories_only,
      key: "reportTemplateCategory",
      subKey: "items",
      context: { clientName: "report" },
    },
    {
      query: Get_Task_Statuses,
      params: { order: { sortOrder: "ASC" }, skip: 0, take: 50 },
      key: "taskStatuses",
      subKey: "items",
    },
    {
      query: Get_Task_Priorities,
      key: "taskPriorities",
      subKey: "items",
      params: { order: { id: "DESC" }, skip: 0, take: 50 },
    },
    {
      query: Get_Task_Types,
      key: "taskTypes",
      subKey: "items",
      params: { order: { id: "DESC" }, skip: 0, take: 50 },
    },
    {
      query: Get_Call_Results,
      key: "callResult",
      subKey: "items",
      params: { skip: 0, take: 100 },
    },
    {
      query: Get_Call_Purpose,
      key: "callPurpose",
      subKey: "items",
      params: { skip: 0, take: 100 },
    },
    {
      query: Get_Lead_Origin_Sub_Types,
      key: "leadOriginSubType",
      params: { where: { id: { neq: 0 } } },
      subKey: "items",
    },
  ];

  return queries;
};

export default dropdownOptionsQueries;
